module.exports = __webpack_public_path__ + "static/leonardo-dicaprio-d9ce8c09f901f49c353ffa5cc52ab9fa.jpg";